/* unplugin-vue-components disabled */import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "tree_item"
};
const _hoisted_2 = ["src", "onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["title"];
const _hoisted_5 = ["src"];
const _hoisted_6 = ["title"];
import { nextTick } from "vue";
export default {
  __name: 'index',
  props: ["att", "event"],
  setup(__props, {
    expose: __expose
  }) {
    const prop = __props;
    const tree = ref(null);
    const isLoad = ref(true);
    const resize = () => {
      isLoad.value = false;
      nextTick(() => {
        isLoad.value = true;
      });
    };
    __expose({
      tree,
      resize
    });
    return (_ctx, _cache) => {
      const _component_el_tree = _resolveComponent("el-tree");
      return _unref(isLoad) ? (_openBlock(), _createBlock(_component_el_tree, _mergeProps({
        key: 0,
        ref_key: "tree",
        ref: tree,
        class: "tree-line",
        indent: 0,
        "node-key": "targetCode",
        "default-expand-all": "",
        props: {
          label: 'targetName',
          value: 'targetCode',
          children: 'evaluationTargetListInfoVoList'
        }
      }, prop.att, _toHandlers(prop.event)), {
        default: _withCtx(({
          node,
          data
        }) => [_createElementVNode("div", _hoisted_1, [!!prop.att?.props ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [__props.event?.imgClick ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 0
        }, [data[prop.att?.props.children]?.length ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: require(node.expanded ? './noAdd.svg' : './add.svg'),
          alt: "",
          style: {
            "z-index": "100"
          },
          onClick: _withModifiers($event => __props.event.imgClick(node, data), ["stop"])
        }, null, 8, _hoisted_2)) : _createCommentVNode("", true)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [data[prop.att?.props.children]?.length ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: require(node.expanded ? './noAdd.svg' : './add.svg'),
          alt: "",
          style: {
            "z-index": "100"
          }
        }, null, 8, _hoisted_3)) : _createCommentVNode("", true)], 64)), _createElementVNode("span", {
          title: data[prop.att.props.label],
          class: _normalizeClass({
            isNotImg: !data[prop.att.props.children]?.length
          })
        }, _toDisplayString(data[prop.att.props.label]), 11, _hoisted_4)], 64)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [data?.evaluationTargetListInfoVoList?.length ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: require(node.expanded ? './noAdd.svg' : './add.svg'),
          alt: ""
        }, null, 8, _hoisted_5)) : _createCommentVNode("", true), _createElementVNode("span", {
          title: data.targetName,
          class: _normalizeClass({
            isNotImg: !data?.evaluationTargetListInfoVoList?.length
          })
        }, _toDisplayString(data.targetName), 11, _hoisted_6)], 64))])]),
        _: 1
      }, 16)) : _createCommentVNode("", true);
    };
  }
};